import Support from '@/generated/classes/Support';
import { SupportNotif as SupportNotifBase } from '@/generated/classes/Support';
export default class SupportExtend extends Support {
  constructor() {
    super();
  }
}
export class SupportNotif extends SupportNotifBase {
  constructor() {
    super();
  }
}
